var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.statusBadgeClass,domProps:{"innerHTML":_vm._s(_vm.display)}})
}
var staticRenderFns = []

export { render, staticRenderFns }